<template>
  <div class="h-100">
    <transition mode="out-in" name="fadeShort">
      <component :is="layout" />
    </transition>
  </div>
</template>
<script>
import DefaultLayout from './layout/Default'
import MinimalLayout from './layout/Minimal'

export default {
  components: {
    DefaultLayout,
    MinimalLayout,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || 'default'}-layout`
    },
  },
}
</script>
